module.exports = __webpack_public_path__ + "static/media/story_08.9d7ab45d.jpg";